module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-controller"
  }, [_c('visualization-button'), _vm._v(" "), _c('building-compass'), _vm._v(" "), _c('switch-pin-type'), _vm._v(" "), _c('visualization-color-chart')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e48c812","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/controller/controller.vue
// module id = 834
// module chunks = 0